import React from 'react';

import APPCONFIG from "constants/Config";

import Framework from "@beardeddevops/react.framework";
import {Breadcrumb, Collections} from "components";

export default class Financials extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">

				<div className="page-bar">
					<ul className="page-breadcrumb">
						<Breadcrumb name={"Financials"} url={"/financials"} icon={"usd"}/>
					</ul>
				</div>

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Collections.Financials
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						locations={this.props.locations}
					/>
				</Framework.Errors.General>

			</div>
		);
	}
}


